import { type AppRole, hasRole as roleGranted } from "@shared/types/roles.ts";

/**
 * Returns true when the Supabase user holds the given role.
 * platform.admin is a wildcard — it satisfies any role check.
 * Use this for all access decisions; never inspect app_metadata.roles directly.
 */
export function hasRole(
  user: { app_metadata?: Record<string, unknown> } | null | undefined,
  role: AppRole
): boolean {
  const roles = user?.app_metadata?.roles;
  if (!Array.isArray(roles)) return false;
  return roleGranted(roles as AppRole[], role);
}
